module.exports = "/_next/static/images/work-02fdb689e388becfefaf1514bf3db595.svg";